import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Define the Firebase configuration object using environment variables
const firebaseConfig = {
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_URL,
};

// Initialize the Firebase app with the configuration object
export const firebaseApp = initializeApp(firebaseConfig);

// Get the Firestore database instance from the initialized Firebase app
export const firestoreDB = getFirestore(firebaseApp);

// Get the Firebase Storage instance from the initialized Firebase app
export const firebaseStorage = getStorage(firebaseApp);

// Get the Firebase Auth instance from the initialized Firebase app
export const firebaseAuth = getAuth(firebaseApp);
